import { Component, EventEmitter, OnInit } from '@angular/core';
import { FormGroup, Validators } from '@angular/forms';
import { Observable } from 'rxjs';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { HotelAvalibilityQuoteResult, HotelQuoteResult } from '@sabstravtech/obtservices/base';

import { LightningModalTypes } from '../../core/classes/modal-types.enum';
import { passwordMismatchValidator } from '../../shared/directives/password-mismatch.directive';

@Component({
  selector: 'app-hotel-result-modal',
  templateUrl: './hotel-result-modal.component.html',
  styleUrls: ['./hotel-result-modal.component.scss'],
  standalone: false
})
export class HotelResultModalComponent implements OnInit {
  constructor(public activeModal: NgbActiveModal) {}

  hotel: HotelQuoteResult = null;
  rooms: HotelAvalibilityQuoteResult = null;
  noOfRooms: number = null;
  changeFilterChain: EventEmitter<string> = null;
  hotelId: string = null;
  isConferma: boolean = null;
  hotelImages: string[] = null;
  thumbUrl: string = null;
  address: string = null;
  hotelRatingsInfo = null;
  index = 0;
  distanceUnit: string = null;
  gmt = false;
  gmtSelectedRoomIndex: number = null;
  ngOnInit(): void {}

  close() {
    if (this.gmt) {
      this.activeModal.close(this.gmtSelectedRoomIndex);
    } else {
      this.activeModal.close();
    }
  }

  changeFilterChainAction(chain: any) {
    if (this.gmt) {
      this.activeModal.close(chain);
    } else {
      this.changeFilterChain.emit(chain);
    }
  }
}

LightningModalTypes.HotelResultModalComponent.component = HotelResultModalComponent;
